import { useSwitchContextMutation } from "Auth/Api/Mutations/Context/useSwitchContextMutation";
import type { SignInResult } from "Infrastructure/Api/Api";
import { setToken } from "Utils/Storage/LocalStorage/LocalStorageUtils";
import { appUrl } from "Utils/UrlUtils";

/**
 * Switches the session into a freshly added role context. Same hard-navigation pattern as the
 * ContextSwitcher: the JWT swap is a major state transition, so the app fully reloads with the
 * new token instead of racing queries against a stale role.
 */
export const useSwitchToNewRole = () => {
  const { mutate: switchContext, isPending: isSwitching } =
    useSwitchContextMutation({
      onSuccess: (result: SignInResult) => {
        setToken(result);
        // Straight into the wizard — the role-based homepage would land elsewhere (e.g. the
        // merchant cash register) and only the route gate would bounce the user back.
        window.location.replace(appUrl("add-role-onboarding"));
      },
    });

  return {
    switchToRole: (identityUserPublicID: string) =>
      switchContext({ identityUserPublicID }),
    isSwitching,
  };
};
